import { render, staticRenderFns } from "./ProductPreparation.vue?vue&type=template&id=449e08b7&scoped=true&"
import script from "./ProductPreparation.vue?vue&type=script&lang=ts&"
export * from "./ProductPreparation.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPreparation.vue?vue&type=style&index=0&id=449e08b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e08b7",
  null
  
)

export default component.exports